import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Heading, Text } from '@atoms';
import { OrderedList } from '@components/RichTextComponents/OrderedList';
import { UnorderedList } from '@components/RichTextComponents/UnorderedList';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';
import { Link } from 'gatsby';
import { theme } from '@theme';

///////--COMPONENTS--///////
import { ContentfulVideo } from '@components/ContentfulVideo';
import { QuoteBlock } from '@components/RichTextComponents/QuoteBlock';
import ImageModal from '../../components/Modal/ImageModal';
import { LottieWrapper } from '../../components/Lottie/LottieWrapper';

export const postDetailResolveRichText = ( contentObject, headingStyles ) => {
  const bodyContent = JSON.parse(contentObject?.body?.raw);
  const references = contentObject?.body?.references;
  const renderOptions = {
    renderText: text => text.split('\n').flatMap((text, i) => [i > 0 && <br />, text]),
    renderMark: {
      [MARKS.BOLD]: text => <span style={{ fontWeight: 'bold', display: 'inline-block' }}>{text}</span>,
      [MARKS.ITALIC]: text => <span style={{ fontStyle: 'italic', display: 'inline-block'}}>{text}</span>,
      [MARKS.UNDERLINE]: text => <span style={{ textDecoration: 'underline', display: 'inline-block' }}>{text}</span>,
    },
    renderNode: {
      [BLOCKS.HEADING_1]: (node, children) => {
        if (children[0]?.props?.style?.fontWeight) {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
              <Heading style={{ ...headingStyles, marginBottom: '20px', fontWeight: "900", fontSize: '50px', lineHeight: '60px' }} headingSize='H1' className="mt-2">     
                <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
              </Heading>
            </div>
          )
        } else if (children[0]?.props?.style?.fontStyle) {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
              <Heading style={{ ...headingStyles, marginBottom: '20px', fontStyle: "italic", fontSize: '50px', lineHeight: '60px' }} headingSize='H1' className="mt-2">     
                <span id={children[0]?.props?.children?.props?.children[1]}>{children[0]?.props?.children?.props?.children}</span>
              </Heading>
            </div>
          )
        } else if (children[0]?.props?.style?.textDecoration) {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
              <Heading style={{ ...headingStyles, marginBottom: '20px', textDecoration: 'underline', fontSize: '50px', lineHeight: '60px', fontWeight: '500'}} headingSize='H1' className="mt-2">     
                <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
              </Heading>
            </div>
          )
        } else {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
                <Heading style={{ ...headingStyles, marginBottom: '20px', fontSize: '50px', lineHeight: '60px', fontWeight: '500' }} headingSize='H1' className="">     
                  <span id={children}>{children}</span>
                </Heading>
            </div>
          )}
        }
      ,
      [BLOCKS.HEADING_2]: (node, children) => {
        if (children[0]?.props?.style?.fontWeight) {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
              <Heading style={{ ...headingStyles, marginBottom: '20px', fontWeight: "900", fontSize: '38px', lineHeight: '46px' }} headingSize='H2' className="mt-2">     
                <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
              </Heading>
            </div>
          )
        } else if (children[0]?.props?.style?.fontStyle) {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
              <Heading style={{ ...headingStyles, marginBottom: '20px', fontStyle: "italic", fontSize: '38px', lineHeight: '46px', fontWeight: '500' }} headingSize='H2' className="">     
                <span id={children[0]?.props?.children?.props?.children[0]}>{children[0]?.props?.children?.props?.children}</span>
              </Heading>
            </div>
          )
        } else if (children[0]?.props?.style?.textDecoration) {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
              <Heading style={{ ...headingStyles, marginBottom: '20px', textDecoration: 'underline', fontSize: '38px', lineHeight: '46px', fontWeight: '500' }} headingSize='H2' className="mt-2">     
                <span id={children[0]?.props?.children[0]}>{children[0]?.props?.children}</span>
              </Heading>
            </div>
          )
        } else {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
                <Heading style={{ ...headingStyles, marginBottom: '20px', fontSize: '38px', lineHeight: '46px', fontWeight: '500' }} headingSize='H2' className="mt-2">     
                  <span id={children}>{children}</span>
                </Heading>
            </div>
          )}
        }
      ,
      [BLOCKS.HEADING_3]: (node, children) => {
        if (children[0]?.props?.style?.fontWeight) {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', fontWeight: "900", borderLeft: '3px solid #69D1F0', paddingLeft: '30px', fontSize: '28px', lineHeight: '34px' }} headingSize='H3' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.fontStyle) {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', fontStyle: "italic", borderLeft: '3px solid #69D1F0', paddingLeft: '30px', fontSize: '28px', lineHeight: '34px', fontWeight: '500' }} headingSize='H3' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.textDecoration) {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', textDecoration: 'underline', borderLeft: '3px solid #69D1F0', paddingLeft: '30px', fontSize: '28px', lineHeight: '34px', fontWeight: '500' }} headingSize='H3' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', borderLeft: '3px solid #69D1F0', paddingLeft: '30px', fontSize: '28px', lineHeight: '34px', fontWeight: '500' }} headingSize='H3' className="mt-2">
              <span id={children}>{children}</span>
            </Heading>  
          )}
        }
      ,
      [BLOCKS.HEADING_4]: (node, children) => {
        if (children[0]?.props?.style?.fontWeight) {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', fontWeight: "900", fontSize: '28px', lineHeight: '34px' }} headingSize='H3' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.fontStyle) {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', fontStyle: "italic", fontSize: '28px', lineHeight: '34px', fontWeight: '500' }} headingSize='H3' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.textDecoration) {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', textDecoration: 'underline', fontSize: '28px', lineHeight: '34px', fontWeight: '500' }} headingSize='H3' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', fontSize: '28px', lineHeight: '34px', fontWeight: '500' }} headingSize='H3' className="mt-2">
              <span id={children}>{children}</span>
            </Heading>  
          )}
        }
      ,
      [BLOCKS.HEADING_5]: (node, children) => {
        if (children[0]?.props?.style?.fontWeight) {
          return (
            <Heading style={{ ...headingStyles, fontWeight: "900", fontSize: '22px', lineHeight: '30px' }} headingSize='H4' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.fontStyle) {
          return (
            <Heading style={{ ...headingStyles, fontStyle: "italic", fontSize: '22px', lineHeight: '30px', fontWeight: '500' }} headingSize='H4' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.textDecoration) {
          return (
            <Heading style={{ ...headingStyles, textDecoration: 'underline', fontSize: '22px', lineHeight: '30px', fontWeight: '500' }} headingSize='H4' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else {
          return (
            <Heading style={{ ...headingStyles, fontSize: '22px', lineHeight: '30px', fontWeight: '500' }} headingSize='H4' className="mt-2">
              <span>{children}</span>
            </Heading>  
          )}
        }
      ,
      [BLOCKS.HEADING_6]: (node, children) => {
        if (children[0]?.props?.style?.fontWeight) {
          return (
            <Heading style={{ ...headingStyles, fontWeight: "900", fontSize: '20px', lineHeight: '28px' }} headingSize='H5' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.fontStyle) {
          return (
            <Heading style={{ ...headingStyles, fontStyle: "italic", fontSize: '20px', lineHeight: '28px', fontWeight: '500' }} headingSize='H5' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.textDecoration) {
          return (
            <Heading style={{ ...headingStyles, textDecoration: 'underline', fontSize: '20px', lineHeight: '28px', fontWeight: '500' }} headingSize='H5' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else {
          return (
            <Heading style={{ ...headingStyles, fontSize: '20px', lineHeight: '28px', fontWeight: '500' }} headingSize='H5' className="mt-2">
              <span>{children}</span>
            </Heading>  
          )}
        }
      ,
      [BLOCKS.PARAGRAPH]: (node, children) => <p style={{marginBottom: '16px'}}>{children}</p>,
      [BLOCKS.UL_LIST]: (node, children) => <BlogUL>{children}</BlogUL>,
      [BLOCKS.OL_LIST]: (node, children) => <BlogOL>{children}</BlogOL>,
      [BLOCKS.QUOTE]: (node, children) => 
        <div>
          <QuotationGraphic>"</QuotationGraphic>
          <Heading style={{ color: '#002DC2' }} headingSize='H3'>{children}</Heading>
        </div>
      ,
      [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
        const id = node.data.target.sys.id;
        const component = references?.filter(subComp => subComp?.contentful_id === id);
        if (component[0]?.internal.type == 'ContentfulComponentImage') {
          if (component[0]?.primaryImage?.file?.contentType?.includes("json")) {
            return <LottieWrapper imageAnimation={component[0]?.primaryImage?.file?.url} />
          } else {
            return <ImageModal reference={component[0]}/>
          }
        } else if (component[0]?.internal.type == 'ContentfulComponentVideo') {
          return (
            <div data-comp='contentfulVIDEO' style={{ padding: '32px 0px' }}>
            <ContentfulVideo videoData={component[0]}/>
          </div>
        )
        } else if (component[0]?.internal?.type?.toLowerCase().includes('quote')) {
            return (
              <div style={{ padding: '32px 0px' }}>
                <QuoteBlock quoteData={component[0]} />
              </div>
          )
        } else {
          console.log('There was an error trying to match and determine component for Blog Detail')
        }
      },
    }
  };
  return documentToReactComponents(bodyContent, renderOptions);
};

const BlogUL = styled.ul`
  margin-left: 24px;
  padding: 0 0 24px 0px;
  li::marker {
    font-size: 26px;
    color: #002DC2;
  }
  li {
    margin-bottom: -10px;
  }
  br {
    display: none;
  }
`

const BlogOL = styled.ol`
  margin-left: 20px;
  padding: 0 0 24px 0px;
  li {
    padding: 5px 0px;
  }
  li::marker {
    font-weight: bold;
  }
  br {
    display: none;
  }
`

const Quote = styled.div`
  // padding: 24px;
  // margin: 0 20px;
  // border-left: 3px solid #69D1F0;
  color: #002DC2;
  font-size: 22px;
  line-height: 30px;
  @media (max-width: 600px) {
    font-size: 16px;
    line-height: 24px;
  }
`

const QuotationGraphic = styled.div`
  margin: 30px 0;
  font-family: News Cycle;
  font-style: normal;
  font-weight: 700;
  font-size: 100px;
  color: #69D1F0;
  transform: rotate(180deg);
  width: fit-content;
  @media (max-width: 576px) {
    font-size: 72px;
  }
`